export default __webpack_public_path__ + "static/media/collaboration.6f0522c4.jpeg";